import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppDialogHelper } from 'general/components/AppDialog';
import AppResource from 'general/constants/AppResource';
import useRouter from 'hooks/useRouter';

function DialogTopupCompletedScreen() {
    const router = useRouter();
    const serialNumber = localStorage.getItem('serialNumber');

    console.log('serialNumber: ', serialNumber);

    useEffect(() => {
        const timer = setTimeout(() => {
            AppDialogHelper.show(
                'Thanh toán thành công',
                'Quý khách đã nạp tiền thành công. Vui lòng chạm thẻ RFID vào khu vực quét thẻ để mở khóa súng sạc và bắt đầu sạc xe.',
                [
                    {
                        title: 'Tôi đã hiểu',
                        type: 'neutral',
                        onClick: () => {
                            AppDialogHelper.hide();
                            router.navigate(serialNumber ? `/topup/${serialNumber}` : '/');
                        },
                    },
                ],
                false,
                AppResource.images.dialogIcons.dialogTopUpSuccess
            );
        }, 100);

        return () => {
            clearTimeout(timer);
            AppDialogHelper.hide();
        };
    }, [router, serialNumber]);

    return (
        <div
            className="min-vh-100 d-flex flex-column align-items-center justify-content-center pt-5"
            style={{
                backgroundImage: `url(${AppResource.images.tmt.bgAuthForm})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        />
    );
}

export default DialogTopupCompletedScreen;